import { ExperienceService } from './../../../core/services/experience.service';
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, input } from '@angular/core';
import { AppButtonComponent } from '../app-button/app-button.component';
import { Router } from '@angular/router';
import { AlertService, AlertType } from 'src/app/core/services/alert.service';
import { PaymentOptionsModalComponent } from '../payment-options-modal/payment-options-modal.component';
import { ModalService } from 'src/app/core/services/modal.service';
import { CustomCurrencyPipe } from 'src/app/shared/pipe/custom-currency.pipe';
import { take } from 'rxjs';

@Component({
  selector: 'app-cards-resgatar',
  standalone: true,
  imports: [
    CommonModule,
    AppButtonComponent,
    PaymentOptionsModalComponent,
    CustomCurrencyPipe,
  ],
  templateUrl: './app-cards-resgatar.component.html',
  styleUrl: './app-cards-resgatar.component.scss',
})
export class AppCardsResgatarComponent implements OnInit {
  modalOptions: string[] = [];
  selectedItem: any;
  labelColor: '#FFFFFF';
  data = input.required<any[]>();
  title = input<string>();
  emptyMessage = input<string>();

  @Input() score: any;
  typeContent = input<string>();
  showItemResgatado = false;

  checkInBtn = {
    buttonText: 'Resgatar',
    borderRadius: '25px',
    buttonSize: 'btn btn-md py-2 btn-primary',
    fontSize: 14,
  };

  buyBtn = {
    buttonText: 'Comprar',
    borderRadius: '25px',
    buttonSize: 'btn btn-md py-2 btn-secondary',
    fontSize: 14,
  };

  constructor(
    private alertService: AlertService,
    private router: Router,
    private experienceService: ExperienceService,
    private modalService: ModalService
  ) { }

  resgatarItem() {
    this.showItemResgatado = true;
  }

  goTo(link: string) {
    if (link?.length > 0) {
      window.open(link, '_blank');
    }
  }

  ngOnInit(): void {
  }

  logdata() {
    console.log(this.data());
  }

  onPaymentOptionSelected(option: string): void {
    setTimeout(() => {
      const body = document.querySelector('body');
      if (body && body.style) {
        body.style.overflow = 'auto';
        body.style.paddingRight = '0px';
      }
    }, 500);

    if (option === 'Usar apenas pontos') {
      this.rescueWithPoints(this.selectedItem);
    }
  }

  private rescueWithPoints(item: any): void {
    if (this.score < item.point) {
      this.alertService.showAlert(
        AlertType.WARNING,
        'Saldo insuficiente para essa experiência'
      );
      return;
    }

    const rescuePayload = {
      memberId: item.memberId,
      experienceId: item.id,
      points: item.point,
    };

    this.experienceService
      .rescueExperience(rescuePayload)
      .pipe(take(1))
      .subscribe({
        next: (res: any) => {
          this.alertService.showAlert(
            AlertType.SUCCESS,
            'Experiência resgatada com sucesso!'
          );
          this.router.navigate(['/resgates'], { state: { rescue: item } });
        },
        error: (err) => {
          const errorMessage =
            err?.error?.message || 'Erro ao resgatar experiência.';
          this.alertService.showAlert(AlertType.DANGER, errorMessage);
        },
      });
  }

  isExpired(validity: string): boolean {
    const today = new Date();
    const validityDate = new Date(validity);
    return validityDate < today;
  }

  mapUsageType(type: string): string {
    switch (type) {
      case 'NEW':
        return 'Adesão';
      case 'RENEW':
        return 'Renovação';
      case 'UPGRADE':
        return 'Upgrade';
      default:
        return type;
    }
  }

  rescueExperience(item: any): void {
    this.selectedItem = item;

    // Cenário 1: Apenas pontos (sem valor monetário)
    if (item.point && !item.value) {
      this.rescueWithPoints(item);
      return;
    }

    // Cenário 2: Pontos do sócio >= valor da experiência
    if (this.score >= item.point) {
      // Mostrar apenas as opções 'Usar apenas pontos' e 'Pagar com dinheiro'
      this.modalOptions = ['Usar apenas pontos', 'Pagar com dinheiro'];
    }
    // Cenário 3: Pontos do sócio < valor da experiência
    else {
      this.modalOptions = ['Pagar com dinheiro', 'Usar pontos do saldo e dinheiro'];
    }

    // Abrir o modal com a experiência selecionada
    this.modalService.open('modal-payment-options');
  }
}